import { render, staticRenderFns } from "./TabSections.vue?vue&type=template&id=37ab754a"
import script from "./TabSections.vue?vue&type=script&lang=js"
export * from "./TabSections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports